var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveIconDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.415039,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2404 11.8221C14.7137 11.0888 15.5404 10.6088 16.4737 10.6088C17.9471 10.6088 19.1404 11.8021 19.1404 13.2754C19.1404 14.2088 18.6604 15.0354 17.9271 15.5088L14.2404 11.8221ZM21.8071 19.3888C21.7937 18.6554 21.3871 17.9821 20.7337 17.6421C20.3737 17.4554 19.9804 17.2821 19.5537 17.1354L21.8071 19.3888ZM22.6004 22.0688L10.3471 9.81543L9.40039 10.7554L15.3271 16.6821C14.1204 16.8354 13.0671 17.2088 12.2137 17.6488C11.5471 17.9888 11.1404 18.6754 11.1404 19.4221V21.2754H19.9204L21.6604 23.0154L22.6004 22.0688Z",
    fill: "#CBC8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIconDisable);
export default __webpack_public_path__ + "static/media/leaveIconDisable.8255319b9d623ebfef099edc428d5838.svg";
export { ForwardRef as ReactComponent };